export interface IExecutable {
  execute(): Promise<void>;
}

export function instanceOfIExecutable(source: unknown): source is IExecutable {
  const casted = source as IExecutable;
  return casted
      && casted.execute !== undefined;
}
